var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.875,
    cy: 21,
    r: 21,
    fill: "#34C759"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.6285V18.3437C22.5 18.3852 22.5165 18.4249 22.5458 18.4542C22.5751 18.4835 22.6148 18.5 22.6563 18.5H28.3715C28.3869 18.5 28.402 18.4954 28.4149 18.4869C28.4277 18.4783 28.4377 18.4661 28.4437 18.4519C28.4496 18.4376 28.4512 18.4219 28.4482 18.4068C28.4452 18.3916 28.4379 18.3777 28.427 18.3668L22.6332 12.573C22.6223 12.5621 22.6083 12.5547 22.5932 12.5518C22.578 12.5488 22.5623 12.5504 22.5481 12.5563C22.5338 12.5622 22.5217 12.5723 22.5131 12.5851C22.5045 12.5979 22.5 12.613 22.5 12.6285Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 19.75C21.4796 19.75 21.4001 19.7171 21.3415 19.6585C21.2829 19.5999 21.25 19.5204 21.25 19.4375V12.25H15.4688C15.3444 12.25 15.2252 12.2994 15.1373 12.3873C15.0494 12.4752 15 12.5944 15 12.7188V29.2812C15 29.4056 15.0494 29.5248 15.1373 29.6127C15.2252 29.7006 15.3444 29.75 15.4688 29.75H28.2812C28.4056 29.75 28.5248 29.7006 28.6127 29.6127C28.7006 29.5248 28.75 29.4056 28.75 29.2812V19.75H21.5625ZM25.625 26H18.125V24.75H25.625V26ZM25.625 22.875H18.125V21.625H25.625V22.875Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrderList);
export default __webpack_public_path__ + "static/media/ic_order_list.d72f85c091ddb20835a072ce33fca357.svg";
export { ForwardRef as ReactComponent };